import React from "react";

export default class NavItemAlgorithm extends React.Component {
	handleClick() {
		console.log("Algorithm");
	}
	render() {
		return (
			<li className="var_nav" onClick={this.handleClick}>
				<div className="link_bg"></div>
				<div className="link_title">
					<div className="icon">
						<i className="fa fa-code fa-2x"></i>
					</div>
					<div className="title">
						<a href="#">
							<span>Algorithm</span>
						</a>
					</div>
				</div>
			</li>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/leftnav/NavItemAlgorithm.jsx
 **/